/**
 * Generador de XML para Declaración ISLR (Seniat)
 * Formato estándar para retenciones de Impuesto Sobre la Renta
 */
export const generateISLRXml = (retenciones = [], empresa = {}) => {
    // Validar datos mínimos
    if (!retenciones || retenciones.length === 0) {
        throw new Error('No hay retenciones para generar el XML');
    }
    if (!empresa || !empresa.rif) {
        throw new Error('Datos de empresa insuficientes (RIF requerido)');
    }

    const rifAgente = empresa.rif.replace(/-/g, '');
    const periodo = (retenciones[0].periodo_fiscal || retenciones[0].periodoFiscal || '').replace(/-/g, ''); // Formato YYYYMM

    let xml = '<?xml version="1.0" encoding="ISO-8859-1"?>\n';
    xml += '<RelacionRetencionesISLR RifAgente="' + rifAgente + '" Periodo="' + periodo + '">\n';

    retenciones.forEach(retencion => {
        // Normalizar datos de cada retención (adaptar según la estructura real de tus datos)
        // Ejemplo de estructura esperada por Seniat (simplificada)
        // Adjust these fields to match your actual data structure in retenciones array

        // Detalle de los ítems de la retención (si la retención agrupa varios documentos, iterar)
        // Asumimos que 'retencion' es un item de la lista de histórico que puede tener detalles
        // Si la data del histórico es resumen, idealmente deberíamos tener los detalles.
        // Pero para el XML de la tabla histórica, usaremos los datos disponibles.

        // NOTA: El formato exacto depende de la normativa vigente. 
        // Aquí se usa un esquema genérico común para Venezuela.

        const isAnulada = retencion.anulada === 1 || retencion.anulada === '1' || retencion.status === 'ANULADA';
        // RIF Retenido también debe ir sin guiones según el Java legacy (.replace("-", ""))
        const rifRetenido = (retencion.proveedor_rif || retencion.rif_proveedor || '').replace(/-/g, '');
        // Factura y Control también se limpian de guiones en el Java legacy (.replace("-", ""))
        // Nota: En JS actual solo limpiábamos RIF. Vamos a limpiar todos para igualar al Java.
        const numeroFactura = (retencion.numero_factura || retencion.numero_documento || '').replace(/-/g, '');
        const numeroControl = (retencion.numero_control || '').replace(/-/g, '');
        const codigoConcepto = retencion.codigo_concepto || '001';

        // Si está anulada, los valores van en cero
        const montoOperacion = isAnulada ? '0.00' : parseFloat(retencion.base || 0).toFixed(2);
        const porcentaje = isAnulada ? '0.00' : parseFloat(retencion.porcentaje || 0).toFixed(2);

        // Fecha de operación: DD/MM/YYYY
        // Evitamos new Date() para no tener problemas de timezone con fechas "YYYY-MM-DD"
        let fechaOperacion = '';
        const fechaRaw = retencion.fecha || ''; // Esperado: YYYY-MM-DD
        if (fechaRaw) {
            // Si viene como objeto Date
            if (fechaRaw instanceof Date) {
                const day = String(fechaRaw.getDate()).padStart(2, '0');
                const month = String(fechaRaw.getMonth() + 1).padStart(2, '0');
                const year = fechaRaw.getFullYear();
                fechaOperacion = `${day}/${month}/${year}`;
            } else if (typeof fechaRaw === 'string' && fechaRaw.includes('-')) {
                // Asumimos YYYY-MM-DD
                const parts = fechaRaw.split('T')[0].split('-');
                if (parts.length === 3) {
                    fechaOperacion = `${parts[2]}/${parts[1]}/${parts[0]}`;
                } else {
                    fechaOperacion = fechaRaw; // Fallback
                }
            } else {
                fechaOperacion = String(fechaRaw);
            }
        }

        xml += '  <DetalleRetencion>\n';
        xml += `    <RifRetenido>${rifRetenido}</RifRetenido>\n`;
        xml += `    <NumeroFactura>${numeroFactura}</NumeroFactura>\n`;
        xml += `    <NumeroControl>${numeroControl}</NumeroControl>\n`;
        xml += `    <FechaOperacion>${fechaOperacion}</FechaOperacion>\n`;
        xml += `    <CodigoConcepto>${codigoConcepto}</CodigoConcepto>\n`;
        xml += `    <MontoOperacion>${montoOperacion}</MontoOperacion>\n`;
        xml += `    <PorcentajeRetencion>${porcentaje}</PorcentajeRetencion>\n`;
        xml += '  </DetalleRetencion>\n';
    });

    xml += '</RelacionRetencionesISLR>';
    return xml;
};
